document.addEventListener("DOMContentLoaded", function() {
  function checkUrl() {
      let url = window.location.href;

      if (url.includes('?variant=')) {
          function getVariantId(url) {
            const urlObj = new URL(url);
            const variantId = urlObj.searchParams.get("variant");
            return variantId;
          }

          const variantId = getVariantId(url);

          const selectedSize =  document.querySelector('.pets-wrapper .selected_size');
          const selectedSizeText = selectedSize.querySelector("span");
          const optionsList = document.querySelector('.pets-wrapper .product-form__options');
          const optionsItems = optionsList.querySelectorAll(".product-form__option");

          selectedSize.addEventListener('click', (e) => {
            optionsList.classList.toggle('show-options-list');
          })
          
          optionsItems.forEach(option => {
            if (option.getAttribute('data-option-id') === variantId) {
              option.classList.add('active');
              selectedSizeText.textContent = option.querySelector('span').textContent.trim();
            }
            
            option.addEventListener('click', (e) => {
              const text = e.currentTarget.querySelector('span').textContent.trim();
              optionsList.classList.remove('show-options-list');
              selectedSizeText.textContent = text;

              optionsItems.forEach(item => {
                item.classList.remove('active');
              })

              option.classList.add('active');
            })
          })
      } else {
          // setTimeout(checkUrl, 100);
          const selectedSize =  document.querySelector('.pets-wrapper .selected_size');
          const selectedSizeText = selectedSize.querySelector("span");
          const optionsList = document.querySelector('.pets-wrapper .product-form__options');
          const optionsItems = optionsList.querySelectorAll(".product-form__option");

          selectedSize.addEventListener('click', (e) => {
            optionsList.classList.toggle('show-options-list');
          })
          
          optionsItems.forEach(option => {
            if (option.classList.contains('active')) {
              const variantActiveID = option.getAttribute('data-option-id');
              const text = option.querySelector('span').textContent.trim();
              console.log(variantActiveID, "VARIANT");
              selectedSizeText.textContent = text;

              const url = new URL(window.location.href);
              url.searchParams.set('variant', variantActiveID);
              window.history.pushState({}, '', url);
            }
            option.addEventListener('click', (e) => {
              const text = e.currentTarget.querySelector('span').textContent.trim();
              optionsList.classList.remove('show-options-list');
              selectedSizeText.textContent = text;

              optionsItems.forEach(item => {
                item.classList.remove('active');
              })

              option.classList.add('active');
            })
          })
      }
  }

  checkUrl();
});
